import type { Register, TextMessage } from '../../types/helsenorge.helseregistre.internalapi.entities.entities';
import type { HNHelseregistreJS } from '../../types/Resources';

export const getErrorMessage = (error: TextMessage | undefined, resources: HNHelseregistreJS | undefined): TextMessage | undefined => {
  if (error) {
    return error.title === 'error' && error.body === 'error' && resources
      ? { title: resources.default_ErrorMessage_Title, body: resources.default_ErrorMessage_Body }
      : error;
  } else {
    return undefined;
  }
};

export const sortRegistre = (registre: Array<Register>): Register[] => {
  return registre.slice().sort((a, b) => (a.navn ? a.navn.localeCompare(b.navn ?? '') : 0));
};
